import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig.js";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming you have a function for logging

const sendPennylaneCreateIndividualClient = async (payload, token, prefix) => {
  // Define the endpoint URL
  const url = prefix + `pennylane/individual-client`;

  // Define the request body
  const body = payload;

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request using fetch API
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Convert body to JSON string
    });

    // Check if the response is okay
    if (!response.ok) {
      console.error(`Failed to create operation: ${response.status}`);
      return `Failed to create operation: ${response.status}`;
    }

    // Parse the response data
    const responseData = await response.json();

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef, // Log the userRef ID
      org_id,
      response.status.toString(), // Response status
      "", // folderid (if needed for logging)
      "", // docid (if needed for logging)
      JSON.stringify(body), // Request body as string,
      "POST"
      // Response body as string
    );

    return responseData;
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default sendPennylaneCreateIndividualClient;
